import { render, staticRenderFns } from "./GenderAgeGraph.vue?vue&type=template&id=5e3ad514&"
import script from "./GenderAgeGraph.vue?vue&type=script&lang=js&"
export * from "./GenderAgeGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports